import classnames from 'classnames';
import Icon, { icons } from '../../generic/Icon';
import { PasswordStrength, MIN_PASSWORD_LENGTH } from '../../../helpers/passwordStrength';

/**
 * An individual "item" or rule which the password is tested against.
 *
 * @param {boolean} isValid - If the password currently passes this rule.
 * @param {string} text - Text explaining the rule.
 */
const PasswordValidationTooltipItem = ({ isValid, text }: { isValid: boolean; text: string; }) => (
  <div className={classnames('fossa-auth__form__password-validation-tooltip__item', {
    'fossa-auth__form__password-validation-tooltip__item--valid': isValid,
  })}>
    <span className="fossa-auth__form__password-validation-tooltip__item__icon">
      {isValid && <Icon icon={icons.check} />}
    </span>
    <span className="fossa-auth__form__password-validation-tooltip__item__text">
      {text}
    </span>
  </div>
);

/**
 * Displays the tooltip explaining if the user's password is valid/invalid.
 *
 * @param {PasswordStrength} strength - The password strength.
 */
const PasswordValidationTooltip = ({ strength }: { strength: PasswordStrength }) => (
  <div className="fossa-auth__form__password-validation-tooltip">
    <div className="fossa-auth__form__password-validation-tooltip__item">
      Your password must have:
    </div>
    <PasswordValidationTooltipItem
      isValid={strength.isLongEnough}
      text={`At least ${MIN_PASSWORD_LENGTH} characters`}
    />
    <PasswordValidationTooltipItem
      isValid={strength.hasLowerCase}
      text="At least one lowercase character (a-z)"
    />
    <PasswordValidationTooltipItem
      isValid={strength.hasUpperCase}
      text="At least one uppercase character (A-Z)"
    />
    <PasswordValidationTooltipItem
      isValid={strength.hasNumber}
      text="At least one number (0-9)"
    />
    <PasswordValidationTooltipItem
      isValid={strength.hasSymbol}
      text="At least one symbol"
    />
  </div>
);

export default PasswordValidationTooltip;
